import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class PartnerTicketTypeService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/partnertickettypes`;

  constructor(private http: HttpClient) { }

  get(partnerId: number): Observable<Boo.Objects.TicketType[]> {
    const params = new HttpParams().set('partnerId', partnerId);

    return this.http.get<Boo.Objects.TicketType[]>(this.baseUrl, { params: params });
  }

  getForNewPartner(): Observable<Boo.Objects.TicketType[]> {
    return this.http.get<Boo.Objects.TicketType[]>(`${this.baseUrl}/GetForNewPartner`);
  }

  replaceAll(partnerId: number, ticketTypeIds: number[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/ReplaceAll`, {
        partnerId,
        ticketTypeIds
    });
  }
}
